import styled from "styled-components"

import { maxWidth, when, unless } from "utils"

import CloudinaryImage from "components/cloudinary-image"
import CountdownTimer from "../countdown"

export const Container = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "flex")};
  justify-content: center;
  align-items: center;
  position: relative;
  padding: ${({ noPadding }) => (noPadding ? "0" : "6.3rem 0")};
  background-color: ${({ theme }) => theme.component.background};
  color: ${({ theme }) => theme.component.text};

  ${unless("alternate")`
    color: rgba(255,255,255,0.65);
    ${({ theme }) =>
      theme.component.text === theme.colors.text.primary &&
      `
      color: rgba(0, 0, 0, 0.65);
    `}
  `}

  ${maxWidth.tablet`
    padding: 3rem 0;
  `}

  ${when("minHeight")`
    min-height: ${({ minHeight }) => minHeight}px;
  `}
`

export const Arrow = styled.div`
  border-style: solid;
  border-width: 0 0.2rem 0.2rem 0;
  display: inline-block;
  padding: 1.8rem;
  transform: rotate(45deg);
  transition: 0.2s;

  ${maxWidth.tablet`
    border-width: 0 0.2rem 0.2rem 0;
    padding: 1.5rem;
  `}
`

export const Content = styled.div`
  display: block;
  text-align: center;
  position: relative;
  max-width: 62%;
  border: ${({ noBorder }) => (noBorder ? "0px" : "1px solid")}; /* inherit border color */
  padding: 3rem 7rem;
  color: inherit;

  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
  `}

  h3 {
    font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 3.4rem;
    font-weight: 400;
    margin-bottom: 2rem;

    ${maxWidth.tablet`
      font-size: 3rem;
    `}
  }

  h4 {
    margin-top: 1rem !important;
  }

  h1 {
    font-size: 6rem;
    color: ${({ theme }) => theme.component.text};

    ${maxWidth.tablet`
      font-size: 3.6rem;
      line-height: 1.35;
    `}
  }

  > div > p {
    font-size: 3rem;
    font-weight: 500;
    line-height: 1.35;
  }

  button {
    margin-top: 1.6rem;
  }

  ${when("alternate")`
    border: 0;
    padding: 0;
  `}

  ${maxWidth.tablet`
    max-width: 65%;

    ${unless("alternate")`
      padding: 3rem;
    `}
  `}

  ${maxWidth.mobile`
    max-width: 90%;
  `}

  :hover ${Arrow} {
    transform: rotate(45deg) scale(1.2);
  }
`

export const OneButtonContainer = styled.div`
  section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 5rem;
`

export const Timer = styled(CountdownTimer)`
  width: 50%;
  margin: 0 auto;
  margin-bottom: 2rem;

  ${maxWidth.desktopL`
    width: 70%;
  `}

  ${maxWidth.desktop`
    width: 80%;
  `}

  ${maxWidth.mobile`
    width: 100%;
  `}
`

export const BackgroundImage = styled(CloudinaryImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Metrics = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  > * {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc((100% / ${({ numMetrics }) => numMetrics}) - 2%);

    ${maxWidth.desktopL`
      flex: 0 0 32%;
      margin-bottom: 2rem;
    `}

    ${maxWidth.tablet`
      flex: 0 0 48%;
    `}

    ${maxWidth.mobileS`
      flex: 0 0 100%;
    `}
  }
`

export const Metric = styled.div`
  box-shadow: -0.2rem 0.2rem 3.5rem -0.1rem rgba(0, 0, 0, 0.75);
  background-color: rgba(25, 25, 25, 0.81);
  border-radius: 0.6rem;
  padding: 2rem;
  color: ${({ theme }) => theme.colors.text.alternate};

  h5 {
    font-size: 3.4rem;
    letter-spacing: 0.2rem;
    margin-bottom: 1rem;
  }

  span {
    font-weight: 500;
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 5rem;

  > :first-child {
    margin-right: 1.5rem;
  }

  > :last-child {
    margin-left: 1.5rem;
  }

  section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  ${maxWidth.desktop`
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > :first-child{
      margin-left: 0;
      margin-right: 0;
    }
    > :last-child {
      margin-left: 0;
      margin-right: 0;
    }
  `}
`
